<!-- Device Configuration Form -->
<form [formGroup]="formGroup" class="form form-container me-3">
  <!-- Section Enregistrement -->
  <div class="config-card mb-3">
    <div class="config-card__header">
      <span class="config-card__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3" fill="currentColor"/>
        </svg>
      </span>
      <b>{{ 'DEVICE_CONFIG.RECORDING_HEADER' | translate }}</b>
    </div>
    <div class="row pt-3">
      <div class="col-12 col-md-4 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.REC_TIME' | translate }}</label>
          <div class="select-field">
            <select class="select-input" formControlName="recTime">
              <option *ngFor="let t of recTimeOptions" [value]="t">{{ t }} s</option>
            </select>
            <span class="select-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.REC_MODE' | translate }}</label>
          <div class="select-field">
            <select class="select-input" formControlName="recMode">
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label | translate }}
              </option>
            </select>
            <span class="select-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-3 d-flex align-items-end">
        
      </div>
      <div class="col-12 col-md-4 pb-3 d-flex align-items-end">
        <div class="switch d-flex align-items-center">
          <input type="checkbox" formControlName="realTUse" id="switch-real-time" />
          <label for="switch-real-time"></label>
          <b class="switch-label">{{ 'DEVICE_CONFIG.REAL_T_USE' | translate }}</b>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.UPLOAD_INTERVAL' | translate }}</label>
          <div class="num-field" [class.num-field--invalid]="formGroup.get('uploadInterval')?.invalid && (formGroup.get('uploadInterval')?.dirty || formGroup.get('uploadInterval')?.touched)">
            <input class="num-input" type="number" formControlName="uploadInterval" min="0" max="60" step="1" />
            <span class="num-unit">min</span>
            <div class="num-spinners">
              <button type="button" (mousedown)="stepField('uploadInterval', 1, 0, 60, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
              </button>
              <button type="button" (mousedown)="stepField('uploadInterval', -1, 0, 60, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
            </div>
          </div>
          <div class="field-error" *ngIf="formGroup.get('uploadInterval')?.invalid && (formGroup.get('uploadInterval')?.dirty || formGroup.get('uploadInterval')?.touched)">
            {{ 'DEVICE_CONFIG.UPLOAD_INTERVAL_ERROR' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section Déclenchement -->
  <div class="config-card mb-3">
    <div class="config-card__header">
      <span class="config-card__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      </span>
      <b>{{ 'DEVICE_CONFIG.TRIGGER_HEADER' | translate }}</b>
    </div>

    <!-- Vibration trigger row -->
    <div class="row align-items-center pt-3">
      <div class="col-12 col-md-5 pb-3">
        <div class="switch d-flex align-items-center">
          <input type="checkbox" formControlName="trgUseVib" id="switch-trg-vib" />
          <label for="switch-trg-vib"></label>
          <b class="switch-label">{{ 'DEVICE_CONFIG.TRG_USE_VIB' | translate }}</b>
        </div>
      </div>
      <div class="col-12 col-md-3 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.PRE_TRG' | translate }}</label>
          <div class="num-field" [class.num-field--invalid]="formGroup.get('preTrg')?.invalid && (formGroup.get('preTrg')?.dirty || formGroup.get('preTrg')?.touched)">
            <input class="num-input" type="number" formControlName="preTrg" min="0" max="500" step="1" />
            <span class="num-unit">ms</span>
            <div class="num-spinners">
              <button type="button" (mousedown)="stepField('preTrg', 1, 0, 500, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
              </button>
              <button type="button" (mousedown)="stepField('preTrg', -1, 0, 500, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
            </div>
          </div>
          <div class="field-error" *ngIf="formGroup.get('preTrg')?.invalid && (formGroup.get('preTrg')?.dirty || formGroup.get('preTrg')?.touched)">
            {{ 'DEVICE_CONFIG.PRE_TRG_ERROR' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.TRG_VIB' | translate }}</label>
          <div class="num-field" [class.num-field--invalid]="formGroup.get('trgVib')?.invalid && (formGroup.get('trgVib')?.dirty || formGroup.get('trgVib')?.touched)">
            <input class="num-input" type="number" formControlName="trgVib" min="0.1" max="200" step="0.01" />
            <span class="num-unit">mm/s</span>
            <div class="num-spinners">
              <button type="button" (mousedown)="stepField('trgVib', 1, 0.1, 200, 0.01)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
              </button>
              <button type="button" (mousedown)="stepField('trgVib', -1, 0.1, 200, 0.01)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
            </div>
          </div>
          <div class="field-error" *ngIf="formGroup.get('trgVib')?.invalid && (formGroup.get('trgVib')?.dirty || formGroup.get('trgVib')?.touched)">
            {{ 'DEVICE_CONFIG.TRG_VIB_ERROR' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Sound trigger row -->
    <div class="row align-items-center">
      <div class="col-12 col-md-5 pb-3">
        <div class="switch d-flex align-items-center">
          <input type="checkbox" formControlName="trgUseSnd" id="switch-trg-snd" />
          <label for="switch-trg-snd"></label>
          <b class="switch-label">{{ 'DEVICE_CONFIG.TRG_USE_SND' | translate }}</b>
        </div>
      </div>
      <div class="col-12 col-md-3 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.TRG_SND' | translate }}</label>
          <div class="num-field" [class.num-field--invalid]="formGroup.get('trgSnd')?.invalid && (formGroup.get('trgSnd')?.dirty || formGroup.get('trgSnd')?.touched)">
            <input class="num-input" type="number" formControlName="trgSnd" min="74" max="140" step="0.1" />
            <span class="num-unit">dB</span>
            <div class="num-spinners">
              <button type="button" (mousedown)="stepField('trgSnd', 1, 74, 140, 0.1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
              </button>
              <button type="button" (mousedown)="stepField('trgSnd', -1, 74, 140, 0.1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
            </div>
          </div>
          <div class="field-error" *ngIf="formGroup.get('trgSnd')?.invalid && (formGroup.get('trgSnd')?.dirty || formGroup.get('trgSnd')?.touched)">
            {{ 'DEVICE_CONFIG.TRG_SND_ERROR' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Section Planification -->
  <div class="config-card mb-3">
    <div class="config-card__header">
      <span class="config-card__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      </span>
      <b>{{ 'DEVICE_CONFIG.PLANNING_HEADER' | translate }}</b>
    </div>

    <!-- Timer row -->
    <div class="row align-items-center pt-3">
      <div class="col-12 col-md-5 pb-3">
        <div class="switch d-flex align-items-center">
          <input type="checkbox" formControlName="tmrUse" id="switch-device-timer" />
          <label for="switch-device-timer"></label>
          <b class="switch-label">{{ 'DEVICE_CONFIG.TMR_USE' | translate }}</b>
        </div>
      </div>
      <ng-container *ngIf="formGroup.get('tmrUse')?.value">
        <div class="col-12 col-md-3 pb-3">
          <div class="input-group input-container">
            <label class="input-label">{{ 'DEVICE_CONFIG.TMR_START_TIME' | translate }}</label>
            <div class="num-field">
              <input class="num-input" type="time" formControlName="tmrStartTime" />
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 pb-3">
          <div class="input-group input-container">
            <label class="input-label">{{ 'DEVICE_CONFIG.TMR_END_TIME' | translate }}</label>
            <div class="num-field">
              <input class="num-input" type="time" formControlName="tmrEndTime" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Active days row -->
    <div class="row align-items-center">
      <div class="col-12 col-md-5 pb-3">
        <div class="input-group input-container">
          <label class="input-label">{{ 'DEVICE_CONFIG.ACTIVE_DAYS' | translate }}</label>
          <div class="day-picker">
            <button
              *ngFor="let day of days"
              type="button"
              class="day-badge"
              [class.day-badge--active]="isDayActive(day.bit)"
              (click)="toggleDay(day.bit)">
              {{ day.key | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Device Configuration Submit Buttons -->
  <div class="fixed-submit-container">
    <button class="fixed-submit-button btn btn-light colored-button" type="button"
            (click)="submitDeviceConfigForm()">
      <img src="icon/save.svg" class="me-2" />
      {{ 'DEVICE_CONFIG.SAVE' | translate }}
    </button>
  </div>
</form>
